import type { IIapProduct } from './IapProductsData';
import { iapProducts } from './IapProductsData';

export const getIapProductById = (productId: string): IIapProduct | undefined =>
  iapProducts.find((product) => product._id === productId);
